module.exports = __webpack_public_path__ + "img/Polygon_Spark_Pro_logo.2c76d396.png";